import { useState } from 'react';
import { Form, Nav, NavItem, NavLink } from 'reactstrap';
import { Search, ChevronDown, ChevronUp } from 'react-feather';
import PropTypes from 'prop-types';
import '../../../helpers/datePickerConfig';
import ModalLoader from '../../../layouts/modals/ModalLoader';
import Loader from '../../../layouts/loader/Loader';
import ModalClickable from '../../../layouts/modals/ModalClickable';
import ListadoAlumnosActas from '../ListadoAlumnosActas';
import useFormularioActa from './hooks/useFormularioActa';
import FiltrosActa from './FiltrosActa';
import AccionesActa from './AccionesActa';

const FormularioActa = ({ isActa }) => {
  const [showFilters, setShowFilters] = useState(true);
  const [importMode, setImportMode] = useState('notas');
  const {
    data,
    fecha,
    activities,
    setActivities,
    activitiesList,
    isLoadingActivitiesList,
    isLoading,
    isProceedingLoading,
    listadoAlumnos,
    alumnosIds,
    allChecked,
    isImporting,
    isDone,
    isImportingRAs,
    isDoneRAs,
    errorModal,
    setErrorModal,
    handleHeadquarter,
    handleCourseYear,
    handleCourse,
    handleType,
    handleGroup,
    handleConvocatoria,
    convocatoria,
    handleFecha,
    handleProceeding,
    handleCheck,
    handleStudent,
    handleStudentsVisibles,
    handleGenerate,
    handleImport,
    handleImportRAs,
    parseDateString,
    resetSelection,
  } = useFormularioActa(isActa, importMode);

  const handleChangeImportMode = (mode) => {
    if (mode === importMode) return;
    resetSelection();
    setImportMode(mode);
  };

  return (
    <>
      {isProceedingLoading ? <ModalLoader header="Generando acta" /> : ''}
      {isImporting ? <ModalLoader header="Importando notas." /> : ''}
      {isImportingRAs ? <ModalLoader header="Importando RAs." /> : ''}
      {isDone ? <ModalClickable header="Notas importadas." /> : ''}
      {isDoneRAs ? <ModalClickable header="RAs importados." /> : ''}
      {errorModal.show && (
        <ModalClickable
          header={errorModal.message}
          body={errorModal.message}
          isVisible={errorModal.show}
          setIsVisible={() => setErrorModal({ show: false, message: '' })}
        />
      )}

      {!isActa && (
        <Nav tabs style={{ marginBottom: '16px' }}>
          <NavItem>
            <NavLink
              className={importMode === 'notas' ? 'active' : ''}
              onClick={() => handleChangeImportMode('notas')}
              style={{ cursor: 'pointer' }}
            >
              Importar notas
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={importMode === 'ras' ? 'active' : ''}
              onClick={() => handleChangeImportMode('ras')}
              style={{ cursor: 'pointer' }}
            >
              Importar RAs
            </NavLink>
          </NavItem>
        </Nav>
      )}

      <Form>
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
            overflow: 'visible',
          }}
        >
          {/* Toolbar */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
            }}
          >
            <button
              type="button"
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: '#374151',
                padding: '4px 8px',
                borderRadius: '6px',
              }}
            >
              <Search size={15} style={{ color: '#9ca3af' }} />
              Filtros
              {showFilters ? (
                <ChevronUp size={14} style={{ color: '#9ca3af' }} />
              ) : (
                <ChevronDown size={14} style={{ color: '#9ca3af' }} />
              )}
            </button>
            <div style={{ display: 'flex', gap: '8px' }}>
              <AccionesActa
                data={data}
                isActa={isActa}
                isLoading={isLoading}
                fecha={fecha}
                listadoAlumnos={listadoAlumnos}
                alumnosIds={alumnosIds}
                activities={activities}
                allChecked={allChecked}
                handleProceeding={handleProceeding}
                handleCheck={handleCheck}
                handleGenerate={handleGenerate}
                handleImport={importMode === 'ras' ? handleImportRAs : handleImport}
                importMode={importMode}
              />
            </div>
          </div>

          {/* Filtros colapsables */}
          {showFilters && (
            <div
              style={{
                padding: '16px',
                opacity: isLoading ? 0.5 : 1,
                pointerEvents: isLoading ? 'none' : 'auto',
                transition: 'opacity 0.2s',
              }}
            >
              {data !== '' ? (
                <FiltrosActa
                  data={data}
                  isLoading={isLoading}
                  isActa={isActa}
                  fecha={fecha}
                  activities={activities}
                  setActivities={setActivities}
                  activitiesList={activitiesList}
                  isLoadingActivitiesList={isLoadingActivitiesList}
                  handleHeadquarter={handleHeadquarter}
                  handleCourseYear={handleCourseYear}
                  handleCourse={handleCourse}
                  handleType={handleType}
                  handleGroup={handleGroup}
                  handleConvocatoria={handleConvocatoria}
                  convocatoria={convocatoria}
                  handleFecha={handleFecha}
                  parseDateString={parseDateString}
                  hideType={importMode === 'ras'}
                />
              ) : (
                <Loader />
              )}
            </div>
          )}
        </div>
      </Form>
      {listadoAlumnos.length > 0 ? (
        <ListadoAlumnosActas
          data={listadoAlumnos}
          alumnosIds={alumnosIds}
          onAlternar={handleStudent}
          onAlternarVisibles={handleStudentsVisibles}
        />
      ) : (
        ''
      )}
    </>
  );
};

FormularioActa.propTypes = {
  isActa: PropTypes.bool,
};

export default FormularioActa;
